module["exports"] = [
  "####",
  "####",
  "####",
  "0###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/postcode.js
// module id = 1316
// module chunks = 1